import brand from '@helpers/brand';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import styled, { createGlobalStyle } from 'styled-components';
import ButtonStyles from '../Button/Button.styles';
const GlobalStyles = createGlobalStyle `
  :root {
    --mobileCtaHeight: 61px;
  }
`;
const Container = styled.div `
  width: 100%;
  display: block;
  background: ${brand.beige};
  padding: 8px;
  z-index: ${Layers.Header};

  ${ButtonStyles.Container} {
    justify-content: center;
    text-align: center;
    width: 100%;
  }

  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const MobileFloatingCtaStyles = {
    Container,
    GlobalStyles,
};
export default MobileFloatingCtaStyles;
